import { useMemo } from 'react';

import { paths } from 'src/routes/paths';

import { useLocalStorage } from 'src/hooks/use-local-storage';

import { useTranslate } from 'src/locales';

import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

export function useNavData() {
  const { t } = useTranslate();
  const { state } = useLocalStorage('entity');

  const entity_id = useMemo(() => state?.id, [state?.id]);
  const parent_entity_id = useMemo(() => state?.parent, [state?.parent]);

  const data = useMemo(
    () => [
      {
        subheader: '',
        items: [
          {
            title: t('nav.menu.dashboard'),
            path: paths.entity.modules.ges.dashboard.root(entity_id, parent_entity_id),
            icon: <Iconify icon="material-symbols:dashboard-outline" />,
          },
          {
            title: t('nav.menu.inventory'),
            path: paths.entity.modules.ges.inventory.root(entity_id, parent_entity_id),
            icon: <Iconify icon="mingcute:inventory-line" />,
          },
          {
            title: t('nav.menu.simulations'),
            path: paths.entity.modules.ges.simulations.root(entity_id, parent_entity_id),
            icon: <Iconify icon="mdi:gauge" />,
          },
          {
            title: t('nav.menu.reuse'),
            path: paths.entity.modules.ges.reuse.root(entity_id, parent_entity_id),
            icon: <Iconify icon="mdi:recycle" />,
          },
          {
            title: t('nav.menu.settings'),
            path: paths.entity.modules.ges.settings.root(entity_id, parent_entity_id),
            icon: <Iconify icon="lucide:settings" />,
          },
        ],
      },
    ],
    [t, entity_id, parent_entity_id]
  );

  return data;
}
